export const comments_3281824 = {"data":{"data":[],"links":{}}}